import { render, staticRenderFns } from "./waypointsCalculator.vue?vue&type=template&id=3b25f7ba"
import script from "./waypointsCalculator.vue?vue&type=script&lang=js"
export * from "./waypointsCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports